import React, { useEffect, useState } from 'react';
import VerificationPopup from '../modals/VerificationPopup';
import styles from '../../styles/newFeature.module.css';
import content from '../../language/ENGLISH.json'
import { HeroSection, StackContainers, StackSkeleton } from '../qbStrap';
import { testimonialData, videoTestimonial } from '@/constants/common';
import FAQ_mobile from '../Industry/FAQ_mobile';
import FrequentQuestions from '../homePage/FrequentQuestions';
import MobilePDBanner from '../common/MobilePDBanner';
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner';
import TestimonialSection from '../common/TestimonialSection';
import MobileTestimonialSection from '../common/MobileTestimonialSection';
import ThreeStepForm from '../common/ThreeStepForm';
import Image from 'next/image';
import OutletFeatures from '../common/OutletFeatures';
import { useRouter } from 'next/router';
import EntertainmentClientsMarquee from './EntertainmentClientsMarquee';

const GamingParlor = () => {
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const [heroReadMore, setHeroReadMore] = useState(false);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const features = [
        {
            id: 1,
            image: "/assets/outlet/gaming-parlor/billing.webp",
            tag: "Point Of Sale",
            icon: "/assets/groceries/kirana/POS.svg",
            title: "Effortless Billing and Invoicing",
            desc: "The QueueBuster Gaming Parlor POS system simplifies your billing process, enabling the production of invoices efficiently and errorfree. With an easy usage interface, it offers a chance to manage many transactions at once, so your customers spend their time playing games—not waiting in a line to pay. Integrated payment methods further reduce the chance of errors and make everything easier for better customer satisfaction.",
            tagColor: "#8AE4F6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Speed up transactions with quick invoice generation.
                </>,
                <>
                    Lower the incidence of billing errors with an integrated payment system.
                </>,
                <>
                    Multiple transactions can be attended to simultaneously.
                </>,
            ],
        },
        {
            id: 2,
            image: "/assets/outlet/gaming-parlor/inventory.webp",
            tag: "Inventory Management",
            icon: "/assets/outlet/iceCreamOutlet/inventoryManagementIcon.svg",
            title: "Advanced Inventory Management",
            desc: "Every gaming parlor should be able to maintain a diverse inventory of games, accessories, and refreshments. The advanced inventory management offered by QueueBuster's POS system keeps you updated with real time stock levels. With each sale, it subtracts from your inventory so that you never face a dearth of stock of any item which sells more quickly than others. You can also set alerts for low stocks so that you may refinance your inventory before it affects your operation.",
            tagColor: "#FFBA00",
            bgColor: "#fff7e2",
            stackColor1: "#FEF8EB",
            stackColor2: "#FEEAC0",
            stackColor3: "#FFD579",
            stackColor4: "#FFC23E",
            sHeight: "10rem",
            eHeight: "26rem",
            msHeight: "15rem",
            meHeight: "41rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Real time inventory tracking to avoid stockouts.
                </>,
                <>
                    The inventory record is auto-updated for accurate accounting.
                </>,
                <>
                    Low stock alerts for the timely restocking process.
                </>,
            ],
        },
        {
            id: 3,
            image: "/assets/outlet/gaming-parlor/clp.webp",
            tag: "CRM & Loyalty",
            icon: "/assets/outlet/giftShopOutlet/CRM.svg",
            title: "Customer Loyalty Programs",
            desc: "Improve customer retention with inbuilt loyalty programs from QueueBuster. This POS allows one to come up with and manage loyalty schemes that allow one to reward customers frequently. Whether through discounts, accumulation of points, or special offers for the members, this feature promotes revisits and customer loyalty.",
            tagColor: "#EEC9FF",
            bgColor: "#fcf6ff",
            stackColor1: "#FCF7FF",
            stackColor2: "#F4E1FF",
            stackColor3: "#EEC9FF",
            stackColor4: "#E4ADFE",
            sHeight: "10rem",
            eHeight: "29rem",
            msHeight: "17rem",
            meHeight: "45rem",
            btnText: "Talk	to an expert",
            points: [
                <>
                    Increase repeat visits with rewards personalized to your best customers.
                </>,
                <>
                    Provide better customer satisfaction due to the achievement of special offers.
                </>,
                <>
                    Make management of loyalty programs intuitive through an easy to use interface.
                </>,
            ],
        },
        {
            id: 4,
            image: "/assets/outlet/gaming-parlor/reporting.webp",
            tag: "Daily Sales Report",
            icon: "/assets/outlet/iceCreamOutlet/report-pos.svg",
            title: "Reporting and Analytics",
            desc: "Make razor sharp business decisions with the detailed reporting and analytics that come with QueueBuster. The POS system provides minute details of trends in sales, customer preferences, and inventory performance. You can create custom reports in data relevant to your business in order to optimize operations and improve profitability. Realtime data access also ensures that you react promptly to changes in the market.",
            tagColor: "#4EEAC2",
            bgColor: "#e6fff9",
            stackColor1: "#C8F4E9",
            stackColor2: "#9EE9D6",
            stackColor3: "#4EEAC2",
            stackColor4: "#47DDB6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    View real time data to make educated decisions.
                </>,
                <>
                    Personalize reports with key business metrics.

                </>,
                <>
                    Drill down for the exact optimization of operations.
                </>,
            ],
        },
        {
            id: 5,
            image: "/assets/outlet/gaming-parlor/multi-location.webp",
            tag: "Multiple Store",
            icon: "/assets/outlet/iceCreamOutlet/multi-store.svg",
            title: "Multi Location Management",
            desc: "In case you have several gaming parlors, the point of sale system at QueueBuster has seamless multi location management. You can maintain control over all your outlets from just one dashboard. Maintaining uniformity of operations and customer service between locations is far easier. This system will allow you to track sales, manage inventory, and track the performance of the staff at each location, among other things, so that you can rest assured that no matter the size of your business, it's running smoothly.",
            tagColor: "#FFC3C3",
            bgColor: "#FFF3F3",
            stackColor1: "#FFF3F3",
            stackColor2: "#FFEBEB",
            stackColor3: "#FFDBDB",
            stackColor4: "#FFC3C3",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "7rem",
            meHeight: "23rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Centralize management across multiple locations.
                </>,
                <>
                    One of the outlets will accord uniform operations and service to another outlet.
                </>,
                <>
                    Ease in monitoring sales and stock at each outlet.
                </>,
            ],
        },
        {
            id: 6,
            image: "/assets/outlet/gaming-parlor/flexible-payment.webp",
            tag: "Digital Payment",
            icon: "/assets/outlet/gaming-parlor/payments.svg",
            title: "Flexible Payment Options",
            desc: "The numerous payment options offered by QueueBuster will definitely bring you closer to catering to customer preferences. The Gaming Parlor POS system accommodates a large variety of payment methods, including cash, UPI, credit/debit cards, mobile wallets, and online payments.",
            tagColor: "#77DFE6",
            bgColor: "#8ae4f626",
            stackColor1: "#D6F6FC",
            stackColor2: "#B0EFFC",
            stackColor3: "#8AE4F6",
            stackColor4: "#70D3E6",
            sHeight: "7rem",
            eHeight: "20rem",
            msHeight: "10rem",
            meHeight: "28rem",
            btnText: "Contact Sales",
            points: [
                <>
                    Provide different ways of payments so customers can be able to pay using their favored method.
                </>,
                <>
                    Sell more by accepting all types of payment methods.
                </>,
                <>
                    Make it easier for them to pay and improve their customer experience.
                </>,
            ],
        },
        // {
        //     id: 7,
        //     image: "/assets/outlet/gaming-parlor/staff-management.webp",
        //     tag: "Employee Management",
        //     icon: "/assets/outlet/gaming-parlor/emp-management.svg",
        //     title: "Efficient Staff Management",
        //     desc: "Running staff at a busy gaming parlor could be very overwhelming, and QueueBuster's Point of Sale can definitely help with that. The scheduling, time tracking, and performance monitoring of your staff are most definitely features that will help you run an efficient team. You will, therefore, get very detailed reports about the sale and productivity of various employees, thereby enabling you to make right decisions on staffing and rewarding your best performers.",
        //     tagColor: "#F8D378",
        //     bgColor: "#fff7e2",
        //     stackColor1: "#FEF8EB",
        //     stackColor2: "#FEEAC0",
        //     stackColor3: "#FFD579",
        //     stackColor4: "#FFC23E",
        //     sHeight: "10rem",
        //     eHeight: "26rem",
        //     msHeight: "15rem",
        //     meHeight: "41rem",
        //     btnText: "Contact Sales",
        //     points: [
        //         <>
        //             Easily manage staff schedules and hours worked
        //         </>,
        //         <>
        //             Track staff performance through detailed reports.
        //         </>,
        //         <>
        //             Motivate top performers to enhance morale and productivity.
        //         </>,
        //     ],
        // },
    ];

    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the QueueBuster Gaming Parlor POS system manage peak hours with several customers who all want to pay at the same time?
                </span>
            ),
            des: "The QueueBuster POS system can efficiently manage peak hours by supporting multiple simultaneous transactions. Either they are groups of friends checking out at the same time or one after another, its userfriendly interface allows staff to process payments much faster and errorfree. Integrated payment methods allow customers to check out their favorite cards, mobile wallets, or online payment options so everyone can be back into the games in no time.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can I use QueueBuster POS to control inventory at several parlours in different gymkhana clubs?
                </span>
            ),
            des: "Yes, of course! Multilocation management goes advanced in the QueueBuster Gaming Parlor POS system. Track and manage parlor inventory from a single dashboard across all your gaming locations. It updates stock levels in real time, whether for video games, accessories, or refreshments you sell, ensuring that you maintain balanced inventory across all locations. More importantly, alerts are sent on lowstock products, allowing you to be proactive in your replenishment cycle and counter stockouts on your highrepeat items.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What if I run a promotional event in my gaming parlor? Is the system capable of managing it?
                </span>
            ),
            des: "QueueBuster Gaming Parlor POS is specially designed to take care of promotional events, be it a discount day, a special tourney, or a loyalty reward offer. Setup and manage promotions across channels, the way it's easiest to do, with this POS system. This lets you handle high transaction volumes during the event, apply offers and discounts automatically during checkout—for a great experience by both staff and customers—and track through realtime analytics how well the promotion is doing in relation to sales and customer engagement.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the QueueBuster POS system enhance customer loyalty in my gaming parlor?
                </span>
            ),
            des: "At the core of QueueBuster's POS is customer loyalty, inbuilt with features that help to create and manage a loyalty program configured to your target audience. It does not matter if it is points for every dollar spent, exclusive discounts for member customers, or specials during birthdays—the system effortlessly keeps tracks of customer rewards. Such loyalty systems encourage repeat visits and can be tailored according to customer preferences to maximize retention and satisfaction.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does a QueueBuster POS help manage staff shifts and performance for a busy gaming parlor?
                </span>
            ),
            des: "The staff management within QueueBuster's POS system is great because it allows ease in scheduling, timetracking through the use of easily assigned shifts, recording of hours worked by employees, and individual sales tracking. Management will get a view, through detailed reports, of where successes are being achieved and where little improvement is taking place. This will not only help optimize levels of staffing during the busy periods but also help motivate the top performers through recognition and rewards.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Are the reports that can be generated through QueueBuster Gaming Parlor POS customized?
                </span>
            ),
            des: "Yes, the reports generated from the QueueBuster POS system can be very detailed and, for all practical purposes, can be customized infinitely when it comes to reporting and analytics. It can design reports as per the business's special needs, like daily sales, customer behavior, inventory, or staff. This report can be customized to display only the data that pertains most to your needs in business, thus facilitating informed decisionmaking to enhance operation and profitability. With realtime access to data, you are always uptodate while making informed strategies.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How does the POS system ensure accurate and efficient billing at the time of massive gaming tournaments or events?
                </span>
            ),
            des: "In a large event, the QueueBuster billing through the POS system is advanced, quick, and very accurate even under huge pressure. This system can handle multiple transactions at a go, all at once, and customers in peak hours will not have to worry about either long queues or any errors in billing. These integrated methods of payments and invoice generations make the system even more efficient, and all participants at this event will be able to center on this event rather than experience a payment bother.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Can QueueBuster Gaming Parlor POS handle different payment methods and in what way does it serve my customers?
                </span>
            ),
            des: "The QueueBuster POS is very flexible when it comes to payments; it accepts credit cards, debit cards, mobile wallets, and online payments. This, therefore, ensures that customers shop comfortably with their preferred modes of payment, enhancing the customer experience. With the accommodation of different payment options, customers are enabled to close transactions with utmost efficiency, hence reducing the chance of losing a sale.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What happens if I lose my internet connection while using the QueueBuster Gaming Parlor POS system?
                </span>
            ),
            des: "The system is conspicuously designed to handle such a situation gracefully. An offline mode is seamlessly integrated into the system for one to go on processing transactions with ease in case there is a breakdown in the internet service. Everything—sales and inventory updates—is carried in the local store, ready to automatically synchronize the instant the line is reestablished. This assures no lost trade, keeping your business running smooth and enabling you to continue providing your customers with good, effective service without any downtime.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How is the QueueBuster POS system considered for contributing to the long run growth of my gaming parlor business?
                </span>
            ),
            des: "The QueueBuster Gaming Parlor POS solution helps in longterm growth by driving operational efficiencies, elevating customer interaction, and delivering actionable insights with powerful reporting and analytics. This system is good to optimize inventory management, improve staff efficiency, and create a strong customer relationship with personalized rewards programs. The dependably seamless service across all touchpoints guarantees scaling effectively but at the same time with high levels of customer satisfaction and profitability.",
            id: 10,
            activeIndex: 0,
        },
    ];

    return (
        <div>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            {
                mobileView ?
                    <div className={styles.hero_section} style={{ backgroundImage: "url('/assets/outlet/gaming-parlor/mobile-hero-img.webp')" }}>
                        <div>
                            <h1>
                                <span>Billing Software for</span><span></span>
                                <span>&nbsp; Gaming Parlor</span>
                            </h1>
                            <p style={{ maxHeight: heroReadMore ? "20rem" : "5rem", overflow: heroReadMore ? 'auto' : "hidden", transition: "1s", marginTop: "2rem" }}>Experience seamless operations and elevated customer satisfaction with the Gaming Parlor POS System by QueueBuster, designed to streamline every aspect of your gaming business.</p>
                            <p className={styles.read_more} onClick={() => setHeroReadMore(!heroReadMore)}>{heroReadMore ? "Read Less" : "Read More"}</p>
                            <div className={styles.btn_container}>
                                <button className={styles.solid_btn} onClick={() => router.push('/contact-form')}>Contact Sales</button>
                            </div>
                        </div>
                    </div>
                    :
                    <div className={styles.sections}>
                        <HeroSection
                            style={{ font: "normal normal bold 5rem/5.5rem Inter", color: "#fff" }}
                            backgroundImg="/assets/outlet/gaming-parlor/hero-img.webp"
                            heading={<> Billing Software for</>}
                            staticHeading={<>Gaming Parlor</>}
                            description={"Experience seamless operations and elevated customer satisfaction with the Gaming Parlor POS System by QueueBuster, designed to streamline every aspect of your gaming business."}
                            solidBtnText={"Contact Sales"}
                            textContainerStyle={{ width: "55%" }}
                            setDemoModal={setDemoModal}
                        />
                    </div>
            }

            <EntertainmentClientsMarquee mobileView={Boolean(mobileView)} />

            <div className={styles.features_section}>
                <div className={styles.section_heading}><h3>Level Up with QB Gaming Parlor POS System</h3><div className={styles.heading_stroke} style={{ width: '12rem' }}><Image src='/assets/industry/restaurant/features_hl 2.svg' alt='stroke' fill /></div></div>
                <OutletFeatures features={features} setDemoModal={setDemoModal} setHeading={setHeading} mobileView={Boolean(mobileView)} />
            </div>

            <div className={styles.three_step_form}>
                <ThreeStepForm mobileView={mobileView} />
            </div>

            <div className={styles.testimonial_section}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>

            <div style={{ marginTop: "6rem" }}>
                {
                    mobileView ?
                        <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"FAQs for Gaming Parlor POS System"} />
                        :
                        <FrequentQuestions FaqTableData={faqs} heading={"FAQs for Gaming Parlor POS System"} />
                }
            </div>

            <div className={styles.demo_banner_section}>
                {
                    mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
                }
            </div>
        </div>
    )
}

export default GamingParlor
